import AnalyticsCard from '@/components/cards/AnalyticsCard';

interface Props {
  stats: { label: string; value: number | undefined; percentage?: number }[];
}

const TopMetrics: React.FC<Props> = ({ stats }) => (
  <div className="grid grid-cols-4 gap-4">
    {stats.map((s) => (
      <AnalyticsCard key={s.label} label={s.label} value={s.value} />
    ))}
  </div>
);

export default TopMetrics;
